import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import PageHero from '@/components/shared/PageHero';
import SectionHeader from '@/components/shared/SectionHeader';
import { publicApi } from '@/lib/api';
import useSEO from '@/hooks/useSEO';
import CSRProjectCard from '@/pages/csr/CSRProjectCard';

export default function OurCSRProjectsPage() {
    const [projects, setProjects] = useState([]);

    useSEO({
        title: 'Our CSR Projects',
        description:
            'Ongoing and completed CSR projects delivered by VVVSI Trust across Tamil Nadu and Puducherry — employment, education, health, environment and disaster relief.',
    });

    useEffect(() => {
        publicApi.getProjects().then(setProjects).catch(() => {});
    }, []);

    const ongoing = projects.filter((p) => p.status === 'ongoing');
    const completed = projects.filter((p) => p.status === 'completed');

    return (
        <div data-testid="our-csr-projects-page">
            <PageHero
                eyebrow="CSR Projects"
                title="Our CSR Projects"
                subtitle="On-ground initiatives — past and present — delivered through a 3,400+ volunteer network."
            />

            <section className="section-pad">
                <div className="container-page">
                    <SectionHeader
                        eyebrow="Delivered on ground"
                        title="Filter by stage."
                        description="Explore projects across employment, education, health, environment and disaster relief."
                    />
                    <div className="mt-8">
                        <Tabs defaultValue="all" data-testid="our-csr-projects-tabs">
                            <TabsList className="bg-[hsl(var(--secondary))]">
                                <TabsTrigger value="all" data-testid="our-csr-tab-all">
                                    All ({projects.length})
                                </TabsTrigger>
                                <TabsTrigger value="ongoing" data-testid="our-csr-tab-ongoing">
                                    Ongoing ({ongoing.length})
                                </TabsTrigger>
                                <TabsTrigger value="completed" data-testid="our-csr-tab-completed">
                                    Completed ({completed.length})
                                </TabsTrigger>
                            </TabsList>
                            {[
                                { key: 'all', arr: projects },
                                { key: 'ongoing', arr: ongoing },
                                { key: 'completed', arr: completed },
                            ].map(({ key, arr }) => (
                                <TabsContent value={key} key={key} className="mt-6">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                                        {arr.map((p, i) => (
                                            <motion.div
                                                key={p.id}
                                                initial={{ opacity: 0, y: 10 }}
                                                whileInView={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.4, delay: i * 0.05 }}
                                                viewport={{ once: true, margin: '-40px' }}
                                            >
                                                <CSRProjectCard p={p} />
                                            </motion.div>
                                        ))}
                                    </div>
                                </TabsContent>
                            ))}
                        </Tabs>
                    </div>
                </div>
            </section>
        </div>
    );
}
